export const getInitials = (user) =>
  user ? [user.first_name?.charAt(0), user.last_name?.charAt(0)].join('').toUpperCase() : null;

export const getAccessToken = () => localStorage.getItem('accessToken') || null;
